/* eslint-disable
    eqeqeq,
*/

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { deepReplace } from 'app/scripts/lib/util/deep-replace';
import { PluginOptions as pluginOptions } from 'app/scripts/views/internal/plugins/PluginOptions';
import xtend from 'xtend';

const PluginProcessCallbacks = (fromPlugin, runCommand) =>
  deepReplace(fromPlugin, function (value) {
    let ref;
    if (value != null && (ref = value._callback) != null) {
      const actionFx = (ref, action) =>
        function (runOptions) {
          if (runOptions == null) {
            runOptions = {};
          }
          return runCommand(
            xtend(runOptions, {
              command: 'callback',
              options: {
                action,
                callback: ref,
                options: pluginOptions(runOptions.options),
              },
            }),
          );
        };
      const fx = actionFx(ref, 'run');
      fx.retain = actionFx(ref, 'retain');
      fx.release = actionFx(ref, 'release');
      return fx;
    }
  });

export { PluginProcessCallbacks };
